<template>
    <div class="QRcode">
        <p class="fz14 black bold mb40">我的二维码</p>
        <img :src="img" alt />
    </div>
</template>

<script>
export default {
    data() {
        return {
            img: this.$store.state.memberInfo.qrcode_img
        };
    }
};
</script>

<style scoped lang="scss">
.QRcode {
    font-size: 14px;
    img {
        width: 324px;
        height: 301px;
        border: 1px solid rgba(112, 112, 112, .3);
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/QRcode/index.vue